
import * as BorderAction from './boardHeader.actionTypes';
import { Dispatch } from 'react';
import { ColumnProps } from '../types/board.types';

export const AddBoardFavData = (payload: ColumnProps) => async (dispatch: Dispatch<BorderAction.BorderHeaderActionTypes>) => {
    try {
        dispatch({
            type: BorderAction.BRD_HEADER_FAV_ADD,
            payload
        });
    }
    catch(e) {

    }
}
export const DelBoardFavData = (payload: ColumnProps) => async (dispatch: Dispatch<BorderAction.BorderHeaderActionTypes>) => {
    try {
        dispatch({
            type: BorderAction.BRD_HEADER_FAV_DEL,
            payload
        });
    }
    catch(e) {

    }
}
export const UpdateBoardHeaderData = (payload: ColumnProps) => async (dispatch: Dispatch<BorderAction.BorderHeaderActionTypes>) => {
    try {
        dispatch({
            type: BorderAction.BRD_UPDATE_BOARD_DATA,
            payload
        });
    }
    catch(e) {

    }
}